export const environment = {
  production: true,
  baseUrl: 'https://www.airtotaalapp.nl/rest',
  baseApiUrl: 'https://www.airtotaalapp.nl/rest/api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts